export const defaultOrgPermissions = {
    //
    // Can view member list, but not member profiles
    'view-members': {
        group: 'Accounts',
        label: 'View Members',
    },
    //
    // Can view member list, but not member profiles
    // Can send messages to full organization or selected members
    'view-and-message-members': {
        group: 'Notifications',
        label: 'View and Message Members',
    },
    //
    // Can view member list, but not member profiles
    // Can transfer members out of organization into another organization
    //   - Need this permission in both organizations
    //   - Transferred members go into Pending status in destination organization
    'view-and-transfer-members': {
        group: 'Accounts',
        label: 'View and Transfer Members',
    },
    //
    // CRUD for members
    // Can export members
    // Can view and edit full profiles of members
    // Can manage groups of members
    'manage-members': {
        group: 'Accounts',
        label: 'Manage Members',
    },
    // Can manage members profile picture
    'manage-profile-picture': {
        group: 'Accounts',
        label: 'Manage Profile Picture',
    },
    //
    // Can edit organization name, visibility, description, organization image, etc.
    // Can create child organizations
    'manage-organization': {
        group: 'Organizations',
        label: 'Manage Organization',
    },
    //
    // Can create messages but cannot send it
    'create-notifications': {
        group: 'Notifications',
        label: 'Create Notifications',
    },
    // Can view organization history of organizations that user is a member of
    'view-organization-history': {
        group: 'Organizations',
        label: 'View Organization History',
    },
};
